
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.125 10.08v10.08a.84.84 0 01-.838.84h-5.87a.838.838 0 01-.839-.84V14.7a.42.42 0 00-.42-.42H7.967a.419.419 0 00-.42.42v5.46a.84.84 0 01-.838.84H.838A.838.838 0 010 20.16V10.08c0-.446.177-.873.492-1.188l8.385-8.4a1.676 1.676 0 012.371 0l8.385 8.4c.315.315.492.742.492 1.188z","fill":"#fff"}})])
          )
        }
      }
    